import React from 'react';
import PropTypes from 'prop-types';

const HeaderTopRight = ({ children }) => <div className="o-grid__item  o-grid__item--shrink  u-push-auto@desktop">
    {children}
  </div>

export default HeaderTopRight;

HeaderTopRight.propTypes = {
  children: PropTypes.node.isRequired,
};
